declare namespace $ {

	type $mol_textarea__hint_shm_hitalama_map_widget_float_code_sql_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_code_sql_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_code_sql_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['sql'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_code_sql_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_code_sql_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_process_view__method_name_shm_hitalama_map_widget_float_code_sql_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_process_view['method_name'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__widget_shm_hitalama_map_widget_float_code_sql_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['widget'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__map_shm_hitalama_map_widget_float_code_sql_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['map'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__Map_page_shm_hitalama_map_widget_float_code_sql_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['Map_page'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__run_shm_hitalama_map_widget_float_code_sql_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['run'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['run'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__Process_shm_hitalama_map_widget_float_code_sql_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_sql['Process'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['Process'] >
	>
	export class $shm_hitalama_map_widget_float_code_sql extends $shm_hitalama_map_widget_float_code_js {
		sql( next?: string ): string
		Textarea_sql( ): $mol_textarea
		Codes( ): $mol_list
		run( ): any
		Process( ): $shm_hitalama_process_view
		Bench( ): $shm_hitalama_map_widget_float_code_bench
		code_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=sql.view.tree.d.ts.map